import { useContext } from 'react';

import type { PageContextType } from './PageContext';
import { PageContext } from './PageContext';

export const usePageContext = () => {
  const context = useContext<PageContextType | undefined>(PageContext);
  if (!context) {
    throw new Error('usePage must be used within a PageProvider');
  }
  return context;
};
